import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_BASE, API_PATH } from './constants';

export const onboardingProgressHandlers = [
  http.patch(`${API_BASE}/${API_PATH}/employee/:employeeId`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
];
